export const hideEmail=(email) => {
  var atIndex = email.indexOf("@");
  var username = email.substring(0, atIndex);
  var domain = email.substring(atIndex);
  
  var hiddenUsername = username.substring(0, 3) + "*".repeat(username.length - 3);
  
  return hiddenUsername + domain;
}
